export default {
	add: 'إضافة بدل',

	headers: {
		value: 'القيمة',
		frequency: 'لكل',
		attendance: 'التأثر بالغياب',
		penalty: 'التأثر بالعقوبات',
	},

	tooltips: {
		hasEffect: 'يتأثر',
		hasntEffect: 'لا يتأثر',
	},

	addAllowance: {
		name: 'اسم البدل',
		price: 'قيمة البدل',
		frequency: 'لكل',
		attendance: 'يتأثر بالغيابات',
		penalty: 'يتأثر بالعقوبات',
	},
};
